import { render, staticRenderFns } from "./ChatContentComponent.vue?vue&type=template&id=6f11c6ea&scoped=true"
import script from "./ChatContentComponent.vue?vue&type=script&lang=js"
export * from "./ChatContentComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatContentComponent.vue?vue&type=style&index=0&id=6f11c6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f11c6ea",
  null
  
)

export default component.exports